import { NEW_CHAT_ID } from '@/utils/constants';

export const FOLLOW_UP_SENT_TITLE = 'Littlebird is working on this.';

export const staysOnHomeAfterSend = (
  threadId: string,
  cardCount: number
): boolean => threadId === NEW_CHAT_ID && cardCount > 0;
